<template>
  <div>
    <div class="pcIndex">
      <div class="top_index">
        <div class="flex-between top_cont">
          <div class="flex-center" style="cursor: pointer" @click="toDeII('meetLove')">
            <img src="../assets/logo.png" alt="" class="logo" />
            <!-- <div class="tit" @click="idx = 1">遇识爱</div> -->
          </div>
          <div class="flex-center">
            <div class="gy" @click="toUrl('http://ysabgshop.yushiai.com.cn/#/login')">商家管理后台</div>
            <div class="gy" @click="toUrl('http://background.yushiai.com.cn/#/login?adv=1')">
              代理商登录
            </div>
            <div class="gy" @click="toDeII('aboutUS')">关于我们</div>
            <div class="gy" @click="toDeII('JoinUS')">招商加盟</div>
          </div>
        </div>

        <div class="flex-align-column cent">
          <div class="cent_tit">上遇识爱 谈场恋爱</div>
          <div class="cent_con">短视频真实婚恋+电商团购</div>
          <div class="flex-center">
            <img v-for="(item, index) in downList" :key="index" :src="item.img" alt="" class="dImg"
              @click="toDown(index)" />
            <!-- <img src="../assets/qr.png" alt="" class="dImg1" /> -->
          </div>
          <div class="cent_down" @click="toDown(1)">点击下载遇识爱app</div>
        </div>
        <div class="wx-min">
          <img src="https://www.yushiai.com.cn/static/pic/904603559.jpg" alt="" class="wx-img" />
          <div class="wx-txt">微信扫一扫 遇识爱小程序</div>
        </div>

        <div class="wx-min" style="left: 30px;">
          <img src="../assets/yqm.png" alt="" class="wx-img" />
          <div class="wx-txt">手机扫码下载 遇识爱APP</div>
        </div>

        <!-- <img src="../assets/yqm.png" alt="" class="yqm" /> -->

        <!-- <img src="https://www.yushiai.com.cn/static/pic/814347843.jpg" alt="" class="wx-min"> -->

        <div class="friendLinks flex-center">
          友情链接：
          <span @click="toUrl('http://www.qugushi.com.cn/')">趣故事官网</span>
          <span @click="toUrl('https://www.niwenwd.com/')">你问我答</span>
          <span @click="toUrl('https://www.gongxiangcesuo.cn/')">城市共享厕所</span>
          <span @click="toUrl('http://www.kuajiangjun.cn/')">夸奖君</span>
        </div>
        <div class="flex-align-column bom">
          <div>
            <span @click="toDe('userAgreement', 1)">用户协议</span> |
            <span @click="toDe('privacyPolicy')">隐私政策</span> |
            <span @click="toDe('FConvention')">中国互联网视听节目服务自律公约</span>
            | <span @click="toDe('broadCast', 'lx')">联系我们</span> |
            <span @click="toDe('broadCast', 'zz')">营业执照</span>
          </div>
          <div>
            <span @click="toDe('broadCast', 'gd')">广播电视节目制作经营许可证</span>
            |
            <span @click="
                toUrl('https://beian.miit.gov.cn/#/Integrated/recordQuery')
              ">闽ICP备2021000902号-5</span>
            | 官方举报邮箱：yushiaijubao@163.com |
            <span @click="
                toUrl(
                  'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35060302000267'
                )
              ">闽公网安备 35060302000267号</span>
            |
            <span @click="toUrl('http://www.qugushi.com.cn/')">漳州趣故事信息技术有限公司</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mobIndex">
      <div class="mob_bj">
        <div class="flex-align-between mb_top">
          <img src="../assets/logo.png" alt="" class="mlogo" />
          <!-- <span class="mTit">遇识爱</span> -->
          <div class="jm" @click="toDeII('JoinUS')">招商加盟</div>
        </div>
        <div class="cent_tit">上遇识爱 谈场恋爱</div>
        <div class="pipei flex-center">高质量配对</div>
        <div class="cent_con">
          <div class="cc_top">
            遇识爱是漳州趣故事信息技术有限公司旗下社交品牌，遇识爱APP，是利用短视频真实婚恋+电商团购，通过大数据匹配帮助全国单身男女用户，解决了单身男女从陌生-约会-恋爱的婚恋过程，赋能全国婚恋产业市场，匹配更精准的真实的婚恋资源。
          </div>
          <img src="../assets/cc_02.png" alt="" class="cc_img" />
          <div class="cc_bom">
            <div>我们宣传口号:上遇识爱谈场恋爱。</div>
            <!-- <div>
              遇识爱APP，专注解决单身男女寻找另一半提供好的平台解决方案，相遇是一种缘分，相识是一种幸运，相爱是一种幸福，遇识爱始终致力于为单身男女营造轻松愉快的社交环境，创造单身男女的幸福感和获得感，让单身男女轻松告别单身，上遇识爱谈场恋爱，寻找属于自己幸福的另一半，相爱就上遇识爱。
            </div> -->
            <div>
              遇识爱APP，是利用短视频真实婚恋+电商团购，通过大数据匹配帮助全国单身男女用户，解决了单身男女从陌生-约会-恋爱的婚恋过程，赋能全国婚恋产业市场，匹配更精准的真实的婚恋资源。遇识爱APP是短视频真实婚恋+电商团购平台，为用户提供视频、购物、约会、一起旅游、交友、互动、等一站式娱乐服务，为用户提供聊天、购物、交友、刷视频、分享等多种在线互动功能。
            </div>
          </div>
        </div>
        <div class="mb_boom flex-center">
          <div class="boom_yu flex-center">遇识爱</div>
          <div class="boom_app flex-center">APP</div>
        </div>
        <div class="down_btn flex-center" @click="toDown(1)">下载</div>
        <div class="mbbb">
          <div>开发者：漳州趣故事信息技术有限公司</div>
          <div>应用名称：遇识爱 版本：安卓、IOS</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "meetLove",
  data() {
    return {
      cont: `<p><strong>遇识爱APP</strong></p><p>遇识爱是漳州趣故事信息技术有限公司旗下社交品牌。</p><p>遇识爱是由漳州趣故事信息技术有限公司开发的一款手机APP，遇识爱APP是单身女性找男性短视频真实婚恋社交平台。</p><p>	&nbsp;</p><p><strong>软件名称：</strong> 遇识爱&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>软件语言：</strong>简体中文</p><p><strong>软件平台：</strong> <span style="color: rgb(51, 51, 51);">Android、&nbsp;&nbsp;iOS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong style="color: rgb(51, 51, 51);">开发商：</strong><span style="color: rgb(51, 51, 51);">&nbsp;漳州趣故事信息技术有公司</span></p><p><strong style="color: rgb(51, 51, 51);">最近更新时间： 2023年 11月29日</strong><span style="color: rgb(51, 51, 51);">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong style="color: rgb(51, 51, 51);">软件版本：</strong><span style="color: rgb(51, 51, 51);">2.0版本</span></p><p><strong style="color: rgb(51, 51, 51);">软件大小：</strong><span style="color: rgb(51, 51, 51);">&nbsp;&nbsp;&nbsp;88M&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></p><p><img src="https://static.niwenwd.com/static/pic/1363627551.png" width="1117" style="cursor: nesw-resize;"></p><p><span style="color: rgb(51, 51, 51);">&nbsp;</span></p><p><span style="color: rgb(51, 51, 51);">1.&nbsp;&nbsp;软件介绍：</span></p><p><span style="color: rgb(51, 51, 51);">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="color: black;">&nbsp;遇识爱APP是单身女性找男性短视频真实婚恋社交平台，遇识爱APP为用户提供视频、交友、互动、等一站式</span><a href="https://baike.baidu.com/item/%E5%A8%B1%E4%B9%90%E6%9C%8D%E5%8A%A1/12745914?fromModule=lemma_inlink" rel="noopener noreferrer" target="_blank" style="color: black;">娱乐服务</a><span style="color: black;">，为用户提供聊天、交友、刷视频、分享等多种在线互动功能。</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></p><p><span style="color: black;">2.&nbsp;&nbsp;软件功能：</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【短视频社交】通过刷短视频，发现感兴趣有共同爱好的异性</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【搭讪聊天】&nbsp;通过感兴趣的异性，向他（她）发起搭讪</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【真实社交】&nbsp;高颜值在线，真实还原美貌</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【发现附近】&nbsp;发现附近的人，近距离聊天体验感不同</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【同城互动】&nbsp;更有同城筛选，满足你不同需求</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【性格适配】&nbsp;针对不同性别有不同的精准定位 筛选异性 进一步找到喜欢的对象</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【礼物互动】&nbsp;对心仪的异性发起礼物 表达心意</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【信息安全】&nbsp;个人主页可选择想展示的基础信息 秉持着用户信息安全原则</span></p><p><span style="color: black;">&nbsp;</span></p><p><span style="color: black;">3.&nbsp;&nbsp;研发者信息：</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;漳州趣故事信息技术有限公司</span></p><p><span style="color: black;">&nbsp;</span></p><p><span style="color: black;">4.&nbsp;&nbsp;支持系统：</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;iOS：</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Android：</span></p><p><span style="color: black;">&nbsp;</span></p><p><span style="color: black;">5.&nbsp;&nbsp;软件初衷：</span></p><p>	<span style="color: black;">2023年中国单身人数已达2亿五千万。其中超过7000万单身者独居。</span></p><p>	<span style="color: black;">全国35岁以上男光棍数量即将突破亿大关。26岁以上未婚的女子超过一亿。</span></p><p><span style="color: black;">2023年我国男性人口的总数比女性多出3362万人。经调查单身时间主要集中在0-2年这个阶段，单身面临的压力来自于各个方面，市场需要更真实的恋爱社交平台。由此有了研发一款真实的短视频，女追男交友软件想法，让女孩子更有选择权，遇识爱APP是单身女性找男性短视频真实婚恋社交平台，遇识爱APP始终致力于为单身男女营造轻松愉快的社交环境，创造单身男女的幸福感和获得感，让单身男女轻松告别单身，上遇识爱谈场恋爱，寻找属于自己幸福的另一半，想爱就上遇识爱。</span></p><p><span style="color: black;">&nbsp;</span></p><p><span style="color: black;">6.&nbsp;&nbsp;注册流程：</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;①用户通过手机号注册一个账号，一个手机号只能注册一个账号，并且必须实名认证。保障用户的合法权益。</span></p><p><span style="color: black;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;②上传头像、选择性别、生日、星座、城市等基础信息，就可以开启一场缘分之旅。</span></p>`,
      lineIdx: 0,
      idx: 1,
      tuo: false,
      lineList: [
        {
          time: "2023年10月",
          desc: "遇识爱正式上线",
        },
        {
          time: "2023年5月",
          desc: "遇识爱开发",
        },
        {
          time: "2021年8月",
          desc: "遇识爱商标品牌落地",
        },
      ],
      downList: [
        {
          img: require("../assets/ipa.png"),
        },
        {
          img: require("../assets/apk.png"),
        },
      ],
    };
  },
  methods: {
    getOS() {
      // 获取当前操作系统
      var os;
      if (
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Linux") > -1
      ) {
        os = "Android";
      } else if (navigator.userAgent.indexOf("iPhone") > -1) {
        os = "iOS";
      } else if (navigator.userAgent.indexOf("Windows Phone") > -1) {
        os = "WP";
      } else {
        os = "Others";
      }
      return os;
    },
    toDown(i) {
      console.log(this.getOS());
      if (i == 0 || this.getOS() == "iOS") {
        console.log("苹果");
        // alert("上线中，敬请期待！");
        window.open(
          "https://apps.apple.com/us/app/%E9%81%87%E8%AF%86%E7%88%B1/id6469745679"
        );
      } else {
        window.open(
          "https://maledeity.obs.cn-north-4.myhuaweicloud.com/static/apk/%E9%81%87%E8%AF%86%E7%88%B1.apk"
        );
        // window.open("https://sj.qq.com/appdetail/com.qm.cn");
      }
    },
    down() {
      let that = this;
      that.tuo = true; //开始播放
      setTimeout(() => {
        that.lineList.push(that.lineList[0]); //将第一条数据塞到最后一个
        that.lineList.shift(); //删除第一条数据
        that.tuo = false; //暂停播放,此处修改，保证每一次都会有动画显示
      }, 500);
    },
    up() {
      let that = this;
      that.tuo = true; //开始播放
      setTimeout(() => {
        that.lineList.push(that.lineList[0]); //将第一条数据塞到最后一个
        that.lineList.shift(); //删除第一条数据
        that.tuo = false; //暂停播放,此处修改，保证每一次都会有动画显示
      }, 500);
    },
    toDe(RouterName, articleMessage) {
      if (window.getSelection().toString() === "") {
        let routeData = this.$router.resolve({
          name: RouterName,
          query: {
            _id: articleMessage || 0,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    toDeII(RouterName) {
      if (window.getSelection().toString() === "") {
        let routeData = this.$router.resolve({
          name: RouterName,
        });
        window.open(routeData.href, "_self");
      }
    },
    toUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>


<style scoped lang="less">
@import "../css/meetLove.less";
// .yqm{
//   width: 200px;
// }
</style>
